import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShield = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M20,11.212a10.38,10.38,0,0,1-7.48,9.716,1.914,1.914,0,0,1-1.04,0A10.38,10.38,0,0,1,4,11.212v-4A2,2,0,0,1,5.243,5.363l4.864-1.99a5,5,0,0,1,3.787,0l4.864,1.99A2,2,0,0,1,20,7.214Z"
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(7.406 7.905)",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M10.62,3.447a1.525,1.525,0,1,1-2.157,0,1.525,1.525,0,0,1,2.157,0",
				transform: "translate(-4.947 -2.851)"
			}), /* @__PURE__ */ _jsx("path", {
				className: "b",
				d: "M6.446,14.008c1.744,0,3.446.753,3.446,1.911V16.3a.383.383,0,0,1-.383.383H3.383A.383.383,0,0,1,3,16.3v-.383c0-1.159,1.7-1.911,3.446-1.911",
				transform: "translate(-1.851 -8.645)"
			})]
		})
	]
});
export default SvgShield;
